<template>
    <div class="right-btn-box">
        <p class="peport">
            <!-- <router-link :to="'/help'">
                Forward instructions
                <i ><svg-icon name="send-email" /></i>
            </router-link> -->
            <a :href="mail_href" target="_blank">
                Forward instructions
                 <i ><svg-icon name="send-email" /></i>
            </a>
        </p>
        <el-button type="primary" @click="$emit('callApi')" :disabled="!permission_domain">I have added the above record to my
            DNS</el-button>

    </div>
</template>

<script>
import { ElButton } from 'element-plus';

export default {
    name: 'DomainCnameBtn',

    components: {
        ElButton
    },

    props: {
        desc: {
            type: String,
            default: 'Configure your custom subdomain by adding the below CNAME record using the instructions below.'
        },

        className: {
            type: [String, Array, Object],
            default: ''
        },

        setup_list: {
            type: Array,
            default: []
        },

        domain_ol: {
            type: Array,
            default: []
        },
    },

    data() {
        return {
            mail_href: '',
        }
    },
    computed: {
        permission_domain(){
            return this.$store.state.user_data?.permission_list?.settingIntegrations?.domainSettings.permission ===100;
        },
    },

    watch: {
    },

    methods: {
        start() {
            let list_text = '';
            let setup_list_text = '';
            for (let i in this.domain_ol) {
                list_text += `${Number(i) + 1}. ${this.domain_ol[i]}\n`;
            }
            for (let i in this.setup_list) {
                if (i < 3) {
                    setup_list_text += `${this.setup_list[i].name}: ${this.setup_list[i].value}\n`;
                }
            }

            let content = `${'DNS Settings'}\n${this.desc}\n\n${setup_list_text}\n${list_text}`;

            //this.mail_href = `mailto:${this.$store.state.mail_to}?subject=Report issue&body=${encodeURIComponent(content)}`;
            this.mail_href = `mailto:?subject=Creator storefront DNS Settings Setup Instructions&body=${encodeURIComponent(content)}`;
        },
    },

    mounted() {
        this.start();
    }

}
</script>
<style lang="scss">

@mixin go-right{
    display: flex;
    align-items: center;
    justify-content: flex-end;
}

.right-btn-box{
    @include go-right;
    flex-wrap: wrap;

    .peport{
        width: 100%;
        @include go-right;
        margin-bottom: 12px;
        margin-top: 12px;
        font: var(--font-med-14);
        font-weight: 400;

        a{
            @include go-right;
            
            i{
                width: 16px;
                height: 16px;
                display: flex;
                justify-content: center;
                align-items: center;
                margin-left: 4px;
            }   

            svg{
                width: 14px;
                height: 12.6px;
                fill: var(--blue);
            }
        }
    }
}
</style> 

